import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { StandardPayment } from "@shared-kernel/application/ports/admin/admin-repository";
import { retrieveTransferList } from "./retrieve-transfer-list";

const initialState: RetrievalState<StandardPayment[]> = { fetching: "idle", data: [] };

export const retrieveTransferListReducer = createReducer<RetrievalState<StandardPayment[]>>(initialState, builder => {
  builder.addCase(retrieveTransferList.fulfilled, (state, { payload }) => {
    return {
      ...state,
      data: payload,
      fetching: "success",
    };
  });
  builder.addCase(retrieveTransferList.pending, state => {
    return {
      ...state,
      fetching: "pending",
    };
  });
  builder.addCase(retrieveTransferList.rejected, state => {
    return {
      ...state,
      fetching: "failed",
    };
  });
});
